"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return FormulaColumn;
    }
});
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _NocoCache = /*#__PURE__*/ _interop_require_default(require("~/cache/NocoCache"));
const _extractProps = require("~/helpers/extractProps");
const _globals = require("~/utils/globals");
const _modelUtils = require("~/utils/modelUtils");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}
let FormulaColumn = class FormulaColumn {
    static async insert(context, formulaColumn, ncMeta = _Noco.default.ncMeta) {
        const insertObj = (0, _extractProps.extractProps)(formulaColumn, [
            'fk_column_id',
            'formula_raw',
            'formula',
            'error',
            'parsed_tree'
        ]);
        insertObj.parsed_tree = (0, _modelUtils.stringifyMetaProp)(insertObj, 'parsed_tree', null);
        await ncMeta.metaInsert2(context.workspace_id, context.base_id, _globals.MetaTable.COL_FORMULA, insertObj);
        return this.read(context, formulaColumn.fk_column_id, ncMeta);
    }
    static async read(context, columnId, ncMeta = _Noco.default.ncMeta) {
        let column = columnId && await _NocoCache.default.get(context, `${_globals.CacheScope.COL_FORMULA}:${columnId}`, _globals.CacheGetType.TYPE_OBJECT);
        if (!column) {
            column = await ncMeta.metaGet2(context.workspace_id, context.base_id, _globals.MetaTable.COL_FORMULA, {
                fk_column_id: columnId
            });
            if (column) {
                column.parsed_tree = (0, _modelUtils.parseMetaProp)(column, 'parsed_tree', null);
                await _NocoCache.default.set(context, `${_globals.CacheScope.COL_FORMULA}:${columnId}`, column);
            }
        }
        // if stored value in cache is string, parse it
        if (column) {
            column.parsed_tree = (0, _modelUtils.parseMetaProp)(column, 'parsed_tree', null);
        }
        return column ? new FormulaColumn(column) : null;
    }
    static async update(context, columnId, formula, ncMeta = _Noco.default.ncMeta) {
        const updateObj = (0, _extractProps.extractProps)(formula, [
            'formula',
            'formula_raw',
            'fk_column_id',
            'error',
            'parsed_tree'
        ]);
        if ('parsed_tree' in updateObj) {
            updateObj.parsed_tree = (0, _modelUtils.stringifyMetaProp)(updateObj, 'parsed_tree', null);
        }
        // set meta
        await ncMeta.metaUpdate(context.workspace_id, context.base_id, _globals.MetaTable.COL_FORMULA, updateObj, {
            fk_column_id: columnId
        });
        // if parsed_tree prop defined in update object, then parse it if string before storing to cache
        if ('parsed_tree' in updateObj) {
            updateObj.parsed_tree = (0, _modelUtils.parseMetaProp)(updateObj, 'parsed_tree', null);
        }
        await _NocoCache.default.update(context, `${_globals.CacheScope.COL_FORMULA}:${columnId}`, updateObj);
    }
    getParsedTree() {
        return this.parsed_tree;
    }
    constructor(data){
        const { parsed_tree } = data, rest = _object_without_properties_loose(data, [
            "parsed_tree"
        ]);
        this.parsed_tree = parsed_tree;
        Object.assign(this, rest);
    }
};
